import { createStore } from 'vuex';

export default createStore({
  state: {
    currentSection: 'home',
    homeRendered: false,
  },
  mutations: {
    setSection(state, section) {
      state.currentSection = section;
    },
    setHomeRendered(state, rendered) {
      state.homeRendered = rendered;
    },
  },
  actions: {},
  modules: {},
});
